<template>
  <Layout :bg="'secondary'">
    <v-progress-circular
      v-if="!userData"
      indeterminate
      color="primary"
      class="absolute-center"
    ></v-progress-circular>
    <div v-else>
      <v-row class="pb-0">
        <v-col cols="12" class="text-right mb-0 pb-0">
          <v-icon
            size="20"
            color="primary"
            @click="$router.push({ name: routeNames.WALLET })"
            >close</v-icon
          >
        </v-col>
      </v-row>
      <v-row class="pt-0 mt-0">
        <v-col cols="1" class="pt-0 mt-0">
          <v-icon size="30" color="primary">star</v-icon>
        </v-col>
        <v-col cols="11" class="pt-0 mt-0">
          <h2 class="textOverSecondary--text font-weight-bold text-h5 pl-2">
            {{ $t("main.my_token") }}
          </h2>
        </v-col>
      </v-row>
      <v-row
        v-if="userData.tokens.length"
        class="primary--text text-center text-subtitle-1"
      >
        <v-col cols="8" class="text-left"> {{ $t("main.products") }} </v-col>
        <v-col cols="4"> {{ $t("main.token") }} </v-col>
      </v-row>
      <v-row
        v-else
        class="align-center justify-center flex-column"
        style="margin-top: 40%"
      >
        <icon
          width="70"
          :color="this.$vuetify.theme.themes.light.primary"
          name="sad_face"
          class="pl-2"
        ></icon>
        <span class="textOverSecondary--text title">{{
          $t("main.no_tokens")
        }}</span>
      </v-row>
      <br />
      <v-row v-for="token in userData.tokens" :key="token.id" class="mx-2 mt-3">
        <TokenButton :token="token"></TokenButton>
      </v-row>
    </div>
  </Layout>
</template>

<script>
import { RequestService } from "../services/request.service";
import errorManager from "../services/error.manager";
import Layout from "@/views/layouts/MainLayout";

const requestService = new RequestService();

export default {
  props: ["auth", "routeNames"],
  data() {
    return {
      userData: null,
    };
  },
  created() {
    this.getUserData();
  },
  components: {
    Layout,
    TokenButton: require("@/components/form-elements/TokenButton").default,
  },
  methods: {
    getUserData() {
      const context = this;
      requestService
        .getUserData(context)
        .then((userData) => {
          context.userData = userData;
        })
        .catch((error) => {
          errorManager.manageError(context, error);
        });
    },
  },
};
</script>
